export default __webpack_public_path__ + "static/blue-cross-6d175c67204a85b0575b840cbd3b5198.png";